import { render, staticRenderFns } from "./BtnCreateWorkspace.vue?vue&type=template&id=e7b99bd0"
import script from "./BtnCreateWorkspace.vue?vue&type=script&lang=ts"
export * from "./BtnCreateWorkspace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports